"use client"

import { useState } from "react"
import { Check, Save } from "lucide-react"
import { Button } from "@/components/ui/button"

/**
 * Explicit "Save progress" button next to an always-on auto-save. `save` writes to this browser's local
 * storage and returns whether it worked. Nothing leaves the device.
 */
export function SaveProgress({ save, savedAt, size = "sm", className }: {
  save: () => boolean
  /** ISO time of the last save, shown as "Saved in this browser". */
  savedAt?: string
  size?: "sm" | "default"
  className?: string
}) {
  const [state, setState] = useState<"idle" | "ok" | "fail">("idle")
  const time = savedAt ? new Date(savedAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : null
  return (
    <span className={`inline-flex flex-wrap items-center gap-2 print:hidden ${className ?? ""}`}>
      <Button type="button" variant="outline" size={size}
        onClick={() => { setState(save() ? "ok" : "fail"); setTimeout(() => setState("idle"), 2500) }}>
        {state === "ok" ? <Check /> : <Save />} {state === "ok" ? "Saved" : "Save progress"}
      </Button>
      <span role="status" className="text-xs text-muted-foreground">
        {state === "fail" ? "This browser blocked saving. Use Summary & export to keep a copy."
          : `Saves automatically as you go${time ? ` · last saved ${time}` : ""}`}
      </span>
    </span>
  )
}
